import Button from "@/components/Button";
import ErrorComponent from "./index";

export default function Error404() {
  return (
    <ErrorComponent>
      <h1 className="display-1 mb-3">404</h1>
      <p className="text-muted">We seem to have misplaced that page.</p>
      <Button to="/" variant="default" className="ml-1">
        Back to Home
      </Button>
    </ErrorComponent>
  );
}
